import ListBlock from './list-block';
export default ListBlock.extend({
  type: 'orderedList',
  tagName: 'ol'
});